import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of} from "rxjs";
import {UserDetail} from "@model";
import {AdministratorsService} from "@services";
import {inject} from "@angular/core";

export const AdministratorsResolver: ResolveFn<Observable<UserDetail[]>> = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
  administratorsService: AdministratorsService = inject(AdministratorsService)
  ): Observable<UserDetail[]> => administratorsService.findAdministrators();

export const AdministratorDetailsResolver: ResolveFn<UserDetail | undefined | null | Observable<UserDetail | undefined | null>> = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): Observable<UserDetail | undefined | null> => {
  const administratorsService = inject(AdministratorsService);
  const userId = route.queryParams['userId'];
  return userId ? administratorsService.fetchUser(+userId) : of({});
};
